export default "/profile/images/bg.png?4b60d401cca35efe1a3ae8ca7cc6b773";